import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--spacing-large);
	flex-direction: column;
	.header {
		display: flex;
		gap: inherit;
		justify-content: space-between;
		align-items: center;
	}

	.card-header-select-size {
		width: var(--px-300);
	}
`;
